<template>
  <div>
    <Head title="Pengumuman" />
    <h1 class="mb-8 text-2xl font-bold">Pengumuman</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link v-if="!isReadOnly()" class="btn-indigo" href="/announcements/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full table-auto">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Judul</th>
          <th class="pb-4 pt-6 px-6">Konten</th>
          <th class="pb-4 pt-6 px-6">Status</th>
          <th v-if="!isReadOnly()" class="pb-4 pt-6 px-6 w-32">Aksi</th>
        </tr>
        <tr v-for="item in announcements.data" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ item.title }}
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4 focus:text-indigo-500 truncate max-w-xs">
              {{ item.content }}
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                <span v-if="item.is_active" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                    Aktif
                </span>
                <span v-else class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                    Tidak Aktif
                </span>
            </div>
          </td>
          <td v-if="!isReadOnly()" class="p-4 w-px border-t">
            <Link class="btn-indigo-sm rounded-l" :href="`/announcements/${item.id}/edit`">
              <font-awesome-icon icon="fas fa-pencil" />
            </Link>
            <Link class="btn-red-sm rounded-r" @click.prevent="destroy(item.id)">
              <font-awesome-icon icon="fas fa-trash" />
            </Link>
          </td>
        </tr>
        <tr v-if="announcements.data.length === 0">
          <td class="px-6 py-4 border-t" :colspan="isReadOnly() ? 3 : 4">Data pengumuman tidak ada.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="announcements.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    FontAwesomeIcon,
  },
  layout: Layout,
  props: {
    filters: Object,
    announcements: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/announcements', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/announcements/${id}`)
        }
      })
    },
  },
}
</script>
